import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Clock, ArrowLeft, Home } from 'lucide-react';
import './ComingSoon.css';

const ComingSoon: React.FC = () => {
  return (
    <div className="coming-soon-page">
      <motion.div
        className="coming-soon-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.div
          className="clock-icon"
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        >
          <Clock size={80} />
        </motion.div>
        
        <h1>Coming Soon</h1>
        <p className="coming-soon-message">
          We're working hard to bring you something amazing!
        </p>
        <p className="coming-soon-submessage">
          This feature is currently under development. Stay tuned for updates.
        </p>
        
        <div className="coming-soon-actions">
          <Link to="/" className="home-button">
            <Home size={20} />
            Back to Home
          </Link>
          <a 
            href="https://wa.me/918962327749?text=Hi, I'm interested in GymsSync. Can we schedule a demo meeting?"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button"
          >
            Contact Us
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default ComingSoon;

